

// import React, { useState, useEffect, useContext } from 'react';
// import axios from 'axios';
// import '../CSS/AllAffiliates.css'; // Keep the existing CSS file
// import { Context } from './Context';
// import Swal from 'sweetalert2';

// const PendingOrders = () => {
//   const { getPendingOrdersUrl, approveOrderUrl, declineOrderUrl } = useContext(Context); // Assume the URLs are provided via context
//   const [orders, setOrders] = useState([]);
//   const [search, setSearch] = useState('');

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const response = await axios.get("https://elexdondigitalacademy.com/api/fetch_pending_orders.php");

//         if (response.data.status === 'success') {
//           setOrders(response.data.data);
//           console.log(response.data.data)
//         } else {
//           console.error('Failed to fetch orders:', response.data.message);
//         }
//       } catch (error) {
//         console.error('Error fetching orders:', error);
//       }
//     };

//     fetchOrders();
//   }, [getPendingOrdersUrl]);



//   const sendOrderEmailFunction = async (orderId,orderuser_id,
//     ordertransaction_reference,
// ordercurrency,
// orderemail,
// ordercart_items,
// ordername,orderorder_date,orderphone,orderreferrer_code,
// ordertotal_amount) => {
//     const loadingAlert = Swal.fire({
//       title: "Loading",
//       text: "Please wait...",
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       showConfirmButton: false
//     });

//     Swal.showLoading();

//     const getCurrentDateTime = () => {
//       const now = new Date();
//       const offset = now.getTimezoneOffset() * 60000;
//       const localTime = new Date(now.getTime() - offset);
//       return localTime.toISOString().slice(0, 19).replace("T", " ");
//     };

//     const orderSummary = {
//       userId: orderuser_id,
//       date: orderorder_date,
//       transactionRef: ordertransaction_reference,
//       name: ordername,
//       phone: orderphone,
//       email: orderemail,
//       referrerCode: orderreferrer_code,
//       cartItems: ordercart_items.map(item => `${item.title} - ₦${new Intl.NumberFormat().format(item.price)}`),
//       total: `₦${ordertotal_amount}`
//     };

//     try {
//       const response = await axios.post("https://elexdondigitalacademy.com/api/send_order_email.php", {
//         buyerEmail: orderemail,
//         sellerEmail: 'info@elexdontech.com',
//         orderSummary: JSON.stringify(orderSummary, null, 2)
//       });

//       if (response.status === 200) {
//         Swal.fire({ icon: "success", text: "Order Approved" });
//       } else {
//         Swal.fire({ icon: "error", text: "Failed to send order summary." });
//       }
//     } catch (error) {
//       Swal.fire({ icon: "error", text: "An error occurred while sending the order summary." });
//     } finally {
//       loadingAlert.close();
//     }
//   };


//   // Handle approving an order
//   const handleApprove = async (orderId,orderuser_id,
//     ordertransaction_reference,
// ordercurrency,
// orderemail,
// ordercart_items,
// ordername,orderorder_date,orderphone,orderreferrer_code,
// ordertotal_amount) => {
//     // Confirmation dialog
//     const result = await Swal.fire({
//       title: 'Are you sure?',
//       text: "Do you want to approve this order?",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, approve it!'
//     });

//     if (result.isConfirmed) {
//       Swal.fire({
//         title: 'Processing...',
//         text: 'Your request is being processed!',
//         allowOutsideClick: false,
//         onBeforeOpen: () => {
//           Swal.showLoading();
//         }
//       });

//       try {
//         const response = await axios.post("https://elexdondigitalacademy.com/api/approve_order.php", { order_id: orderId });

//         if (response.data.status === 'success') {
//           Swal.fire('Approved!', 'The order has been approved.', 'success');
//           setOrders((prevOrders) => prevOrders.filter((order) => order.id !== orderId));
//           sendOrderEmailFunction(orderId,orderuser_id,
//             ordertransaction_reference,
//         ordercurrency,
//         orderemail,
//         ordercart_items,
//         ordername,orderorder_date,orderphone,orderreferrer_code,
//         ordertotal_amount)
//         } else {
//           Swal.fire('Error!', response.data.message, 'error');
//           console.error('Failed to approve order:', response.data.message);
//         }
//       } catch (error) {
//         Swal.fire('Error!', 'An error occurred while approving the order.', 'error');
//         console.error('Error approving order:', error);
//       }
//     }
//   };





//   // Handle declining an order
//   const handleDecline = async (orderId) => {
//     // Confirmation dialog
//     const result = await Swal.fire({
//       title: 'Are you sure?',
//       text: "Do you want to decline this order?",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, decline it!'
//     });

//     if (result.isConfirmed) {
//       Swal.fire({
//         title: 'Processing...',
//         text: 'Your request is being processed!',
//         allowOutsideClick: false,
//         onBeforeOpen: () => {
//           Swal.showLoading();
//         }
//       });

//       try {
//         const response = await axios.post("https://elexdondigitalacademy.com/api/decline_order.php", { order_id: orderId });

//         if (response.data.status === 'success') {
//           Swal.fire('Declined!', 'The order has been declined.', 'success');
//           setOrders((prevOrders) => prevOrders.filter((order) => order.id !== orderId));
//         } else {
//           Swal.fire('Error!', response.data.message, 'error');
//           console.error('Failed to decline order:', response.data.message);
//         }
//       } catch (error) {
//         Swal.fire('Error!', 'An error occurred while declining the order.', 'error');
//         console.error('Error declining order:', error);
//       }
//     }
//   };


//   const filteredOrders = orders.filter(order =>
//     order.transaction_reference.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div className="affiliates-wrapper" style={{ width: "100%" }}>
//       <h1 className="affiliates-heading">Pending Orders</h1>
//       <input
//         type="text"
//         placeholder="Search by Transaction Reference"
//         value={search}
//         onChange={(e) => setSearch(e.target.value)}
//         className="affiliates-search-input"
//       />
//       <div className="affiliates-list">
//         {filteredOrders.length > 0 ? (
//           filteredOrders.map((order) => (
//             <div key={order.id} className="affiliate-card">
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Customer Name:</span>
//                 <span className="affiliate-value">{order.name}</span>
//               </div>
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Email:</span>
//                 <span className="affiliate-value">{order.email}</span>
//               </div>
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Phone:</span>
//                 <span className="affiliate-value">{order.phone}</span>
//               </div>
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Transaction Reference:</span>
//                 <span className="affiliate-value">{order.transaction_reference}</span>
//               </div>
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Total Amount:</span>
//                 <span className="affiliate-value">NGN {order.total_amount}</span>
//               </div>
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Order Date:</span>
//                 <span className="affiliate-value">{new Date(order.order_date).toLocaleDateString()}</span>
//               </div>
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Cart items:</span>
//                 {order.cart_items.map((cartItem) => (
//                   <div className="affiliate-value" style={{ display: "flex", gap: "5px" }} key={cartItem.id}>
//                     <p>Course ID: {cartItem.id},</p>
//                     <p>{cartItem.title}</p>
//                     <p>NGN {cartItem.price}</p>
//                   </div>
//                 ))}
//               </div>
//               <div>
//                 <button
//                   onClick={() => handleApprove(order.id,order.user_id,
//                     order.transaction_reference,
//                 order.currency,
//             order.email,
//         order.cart_items,
//     order.name,order.order_date,order.phone,order.referrer_code,
// order.total_amount)}
//                   style={{
//                     padding: "5px",
//                     border: "none",
//                     borderRadius: "5px",
//                     marginRight: "10px",
//                     cursor: "pointer",
//                     backgroundColor: "rgba(0,0,255,0.5)",
//                     color: "white"
//                   }}
//                 >
//                   Approve
//                 </button>
//                 <button
//                   onClick={() => handleDecline(order.id)}
//                   style={{
//                     padding: "5px",
//                     border: "1px solid blue",
//                     borderRadius: "5px",
//                     marginRight: "10px",
//                     cursor: "pointer",
//                     backgroundColor: "white",
//                     color: "blue"
//                   }}
//                 >
//                   Decline
//                 </button>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div>No pending orders found.</div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PendingOrders;




// src/components/PendingOrders.jsx
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Context } from './Context';
import Swal from 'sweetalert2';
import styled from 'styled-components';

const PendingOrders = () => {
  const { getPendingOrdersUrl } = useContext(Context);
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const url = getPendingOrdersUrl || "https://elexdondigitalacademy.com/api/fetch_pending_orders.php";
        const response = await axios.get(url);

        if (response.data.status === 'success') {
          setOrders(response.data.data);
        } else {
          console.error('Failed to fetch orders:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [getPendingOrdersUrl]);

  const sendOrderEmailFunction = async (
    orderId, orderuser_id, ordertransaction_reference, ordercurrency,
    orderemail, ordercart_items, ordername, orderorder_date, orderphone,
    orderreferrer_code, ordertotal_amount
  ) => {
    const loadingAlert = Swal.fire({
      title: "Loading",
      text: "Please wait...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading()
    });

    const orderSummary = {
      userId: orderuser_id,
      date: orderorder_date,
      transactionRef: ordertransaction_reference,
      name: ordername,
      phone: orderphone,
      email: orderemail,
      referrerCode: orderreferrer_code,
      cartItems: ordercart_items.map(item => `${item.title} - ₦${new Intl.NumberFormat().format(item.price)}`),
      total: `₦${ordertotal_amount}`
    };

    try {
      const response = await axios.post("https://elexdondigitalacademy.com/api/send_order_email.php", {
        buyerEmail: orderemail,
        sellerEmail: 'info@elexdontech.com',
        orderSummary: JSON.stringify(orderSummary, null, 2)
      });

      if (response.status === 200) {
        Swal.fire({ icon: "success", text: "Order Approved & Email Sent" });
      } else {
        Swal.fire({ icon: "error", text: "Failed to send order summary." });
      }
    } catch (error) {
      Swal.fire({ icon: "error", text: "An error occurred while sending the order summary." });
    } finally {
      loadingAlert.close();
    }
  };

  const handleApprove = async (
    orderId, orderuser_id, ordertransaction_reference, ordercurrency,
    orderemail, ordercart_items, ordername, orderorder_date, orderphone,
    orderreferrer_code, ordertotal_amount
  ) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to approve this order?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2563eb',
      cancelButtonColor: '#dc2626',
      confirmButtonText: 'Yes, approve it!'
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Processing...',
        text: 'Your request is being processed!',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      try {
        const response = await axios.post("https://elexdondigitalacademy.com/api/approve_order.php", { order_id: orderId });

        if (response.data.status === 'success') {
          setOrders((prevOrders) => prevOrders.filter((order) => order.id !== orderId));
          sendOrderEmailFunction(
            orderId, orderuser_id, ordertransaction_reference, ordercurrency,
            orderemail, ordercart_items, ordername, orderorder_date, orderphone,
            orderreferrer_code, ordertotal_amount
          );
        } else {
          Swal.fire('Error!', response.data.message, 'error');
        }
      } catch (error) {
        Swal.fire('Error!', 'An error occurred while approving the order.', 'error');
      }
    }
  };

  const handleDecline = async (orderId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to decline this order?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2563eb',
      cancelButtonColor: '#dc2626',
      confirmButtonText: 'Yes, decline it!'
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Processing...',
        text: 'Your request is being processed!',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      try {
        const response = await axios.post("https://elexdondigitalacademy.com/api/decline_order.php", { order_id: orderId });

        if (response.data.status === 'success') {
          Swal.fire('Declined!', 'The order has been declined.', 'success');
          setOrders((prevOrders) => prevOrders.filter((order) => order.id !== orderId));
        } else {
          Swal.fire('Error!', response.data.message, 'error');
        }
      } catch (error) {
        Swal.fire('Error!', 'An error occurred while declining the order.', 'error');
      }
    }
  };

  const filteredOrders = orders.filter(order =>
    order.transaction_reference?.toLowerCase().includes(search.toLowerCase()) ||
    order.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <PageContainer>
      <HeaderSection>
        <div>
          <h2>Pending Orders</h2>
          <p>Review, approve, or decline pending payment transactions.</p>
        </div>
        <SearchInput
          type="text"
          placeholder="Search by ref or name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </HeaderSection>

      {loading ? (
        <LoadingState>Loading pending orders...</LoadingState>
      ) : filteredOrders.length > 0 ? (
        <OrdersGrid>
          {filteredOrders.map((order) => (
            <OrderCard key={order.id}>
              <OrderCardHeader>
                <div>
                  <span className="ref-label">Transaction Ref</span>
                  <h4>{order.transaction_reference}</h4>
                </div>
                <Badge>Pending</Badge>
              </OrderCardHeader>

              <InfoGrid>
                <InfoItem>
                  <span className="label">Customer Name</span>
                  <span className="value">{order.name}</span>
                </InfoItem>
                <InfoItem>
                  <span className="label">Email Address</span>
                  <span className="value">{order.email}</span>
                </InfoItem>
                <InfoItem>
                  <span className="label">Phone Number</span>
                  <span className="value">{order.phone || 'N/A'}</span>
                </InfoItem>
                <InfoItem>
                  <span className="label">Total Amount</span>
                  <span className="value amount">₦{Number(order.total_amount).toLocaleString()}</span>
                </InfoItem>
                <InfoItem>
                  <span className="label">Order Date</span>
                  <span className="value">{new Date(order.order_date).toLocaleDateString()}</span>
                </InfoItem>
              </InfoGrid>

              <CartSection>
                <span className="label">Cart Items</span>
                <CartList>
                  {order.cart_items?.map((cartItem) => (
                    <CartItemRow key={cartItem.id}>
                      <span>{cartItem.title}</span>
                      <span className="item-price">₦{Number(cartItem.price).toLocaleString()}</span>
                    </CartItemRow>
                  ))}
                </CartList>
              </CartSection>

              <ActionButtons>
                <ApproveButton
                  onClick={() => handleApprove(
                    order.id, order.user_id, order.transaction_reference, order.currency,
                    order.email, order.cart_items, order.name, order.order_date, order.phone,
                    order.referrer_code, order.total_amount
                  )}
                >
                  Approve Order
                </ApproveButton>
                <DeclineButton onClick={() => handleDecline(order.id)}>
                  Decline Order
                </DeclineButton>
              </ActionButtons>
            </OrderCard>
          ))}
        </OrdersGrid>
      ) : (
        <EmptyState>No pending orders found.</EmptyState>
      )}
    </PageContainer>
  );
};

export default PendingOrders;

// --- Styled Components ---
const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  font-family: inherit;
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;

  h2 {
    color: #0f172a;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 4px 0;
  }

  p {
    color: #64748b;
    font-size: 0.95rem;
    margin: 0;
  }
`;

const SearchInput = styled.input`
  padding: 10px 16px;
  width: 280px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 0.95rem;
  outline: none;
  background-color: #ffffff;
  transition: all 0.2s ease;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const LoadingState = styled.div`
  text-align: center;
  padding: 48px;
  color: #64748b;
  font-size: 1rem;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 48px;
  color: #64748b;
  font-size: 1rem;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const OrdersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
`;

const OrderCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const OrderCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;

  .ref-label {
    font-size: 0.75rem;
    text-transform: uppercase;
    color: #64748b;
    font-weight: 600;
  }

  h4 {
    margin: 2px 0 0 0;
    color: #0f172a;
    font-size: 1rem;
    font-family: monospace;
  }
`;

const Badge = styled.span`
  background: #fef3c7;
  color: #d97706;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  .label {
    font-size: 0.75rem;
    color: #64748b;
    text-transform: uppercase;
    font-weight: 600;
  }

  .value {
    font-size: 0.9rem;
    color: #1e293b;
    font-weight: 500;

    &.amount {
      color: #16a34a;
      font-weight: 700;
    }
  }
`;

const CartSection = styled.div`
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  padding: 12px;

  .label {
    display: block;
    font-size: 0.75rem;
    color: #64748b;
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 8px;
  }
`;

const CartList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CartItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #334155;

  .item-price {
    font-weight: 600;
    color: #0f172a;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 4px;
`;

const ApproveButton = styled.button`
  flex: 1;
  padding: 10px;
  background-color: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #1d4ed8;
  }
`;

const DeclineButton = styled.button`
  flex: 1;
  padding: 10px;
  background-color: #ffffff;
  color: #dc2626;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #fef2f2;
  }
`;